export default __webpack_public_path__ + "static/heroSectionBg-36257bf27d6f4048264a9db70dfb9b01.png";